import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';

/**
 * Utility function to merge Tailwind classes and conditional classNames.
 *
 * @param  {...any} classes - Class names or class conditions.
 * @returns {string} - A merged string of class names.
 */
// eslint-disable-next-line import/prefer-default-export
export const cn = (...classes) => twMerge(classNames(...classes));
